
import colors from '../../../../styles/colors.module.scss';

export const rangesProps = [
    {
      min: 0,
      max: 15,
      position: { top: 107, left: 15 },
      degree: -124,
      color: '#FE4929'
    },
    {
      min: 16,
      max: 31,
      position: {
        top: 46,
        left: 12,
      },
      degree: -70,
      color: '#F05F46'
    },
    {
      min: 32,
      max: 47,
      position: { top: 2 },
      degree: 0,
      color: '#F89229'
    },
    {
      min: 48,
      max: 63,
      position: {
        top: 32,
        right: 20,
      },
      degree: 55,
      color: '#FCC317'
    },
    {
      min: 64,
      max: 80,
      position: {
        top: 105,
        right: 13,
      },
      degree: 115,
      color: colors.primary
    },
  ];